/*
 * Copyright Huesik (c) 2019.
 */

const Menu = {
  MAIN: [
    {
      NAME: '메인',
      HREF: '/',
      TARGET: (mq) => {
        return mq === 'sm'
      },
      CLASS: 'main'
    },
    {
      NAME: '지도로 찾기',
      HREF: '/search?latitude=37.5546788388674&longitude=126.970606917394',
      CLASS: 'map',
      TARGET: (mq) => {
        return mq !== 'sm'
      },
    },
    {
      NAME: '지도',
      HREF: '/search?latitude=37.5546788388674&longitude=126.970606917394',
      CLASS: 'map',
      TARGET: (mq) => {
        return mq === 'sm'
      },
    },
    {
      NAME: '관심목록',
      HREF: '/interest',
      CLASS: 'interest'
    },
    // {
    //   NAME: '로그인/회원가입',
    //   HREF: 'modal/login-modal',
    //   SHOW_LOGIN: false
    // }, {
    //   NAME: '로그아웃',
    //   HREF: 'logout',
    //   SHOW_LOGIN: true
    // },
    {
      NAME: '고시원 등록',
      // HREF: 'external_url/http://ad.kosirock.com/#/register',
      HREF: '/register',
      // HREF: 'external_url/https://forms.gle/9LBmavTC1ekqDYxf8',
      TARGET: (mq) => {
        return mq !== 'sm'
      }
    },
    {
      NAME: '고시원 창업',
      HREF: 'external_url/https://huesik.co.kr/',
      TARGET: (mq) => {
        return mq !== 'sm'
      }
    },
    {
      NAME: '고시락 패키지',
      HREF: 'external_url/https://forms.gle/U1ge5vr31bN6bFpo7',
      TARGET: (mq) => {
        return mq !== 'sm'
      }
    },
    // 현재 css 문제로 인해서 사용 불가
    // 추후 페이지 개발 예정.  
    //   {
    //   NAME: '고시원 올리기',
    //   HREF: '/register',
    //   TARGET: (mq) => {
    //     console.log(mq);
    //     return mq !== 'sm'
    //   }
    // },
    // {
    //   NAME: '고시원 매매 문의',
    //   HREF: 'external_url/https://forms.gle/UNPLbQFMYV5ZFZ5cA',
    //   TARGET: (mq) => {
    //     console.log(mq !== 'sm')
    //     return mq !== 'sm'
    //   }
    // },
    {
      NAME: '더보기',
      HREF: '/more',
      TARGET: (mq) => {
        return mq === 'sm'
      },
      CLASS: 'more'
    }]
}

export default Menu

